import { Injectable } from "@angular/core";
import { ApproveRejectNotification } from "../../api/models/approveRejectNotification";
import { CommonUserAttributesService } from "../upplm.commonUserAttributes.service";
import { ConfigurationService } from "../upplm.configuration.service";
import { StoredDataService } from "../upplm.storedData.service";


@Injectable()

export class NotificationChangesHelperService {
    constructor(private _storedDataService: StoredDataService,
        private _commonUserAttributesService: CommonUserAttributesService,
        private _configurationService: ConfigurationService    ) { }

    setAdditionalValuesToEditRequest(changeJustification: string, emails: any[]) {
        this._storedDataService.addChangeJustification = changeJustification;
        this._storedDataService.addNotifications = this.getNotifications(emails);
        this._storedDataService.setTransactionSource();
        this._storedDataService.addInternalUserEmailToRequest = this._storedDataService.userEmail;
        this._storedDataService.addUserNameToRequest = this._storedDataService.userName;
        this._storedDataService.addInternalUserNameToRequest = this._storedDataService.internalUserName;
    }

    private getNotifications(emails: any[]): ApproveRejectNotification[] {
        let notificationsArray: ApproveRejectNotification[] = [];
        let notification: ApproveRejectNotification;

        emails.forEach(emailBox => {
            notification = new ApproveRejectNotification();
            notification.email = emailBox.email;
            notification.notifyApproved = emailBox.notifyApproved;
            notification.notifyRejected = emailBox.notifyRejected;
            notificationsArray.push(notification);
        });
        return notificationsArray;
    }
}